const BranchSelect = ({ branch, setBranch }) => {
    return (
        <div className="w-full max-w-32">
            <select
                value={branch}
                onChange={(e) => setBranch(e.target.value)}
                className="block w-full px-2 py-2 bg-white border border-gray-300 rounded-md shadow-sm"
            >
                <option value="yakkala">Yakkala</option>
                <option value="colombo">Colombo</option>
            </select>
        </div>
    )
}

export default BranchSelect